var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControlsIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:control-camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9704 17.5291C12.9982 17.5291 12.1718 17.1889 11.4912 16.5083C10.8107 15.8278 10.4704 15.0014 10.4704 14.0291C10.4704 13.0569 10.8107 12.2305 11.4912 11.55C12.1718 10.8694 12.9982 10.5291 13.9704 10.5291C14.9426 10.5291 15.769 10.8694 16.4495 11.55C17.1301 12.2305 17.4704 13.0569 17.4704 14.0291C17.4704 15.0014 17.1301 15.8278 16.4495 16.5083C15.769 17.1889 14.9426 17.5291 13.9704 17.5291ZM13.9704 25.6666L9.01204 20.7083L10.6745 19.0458L13.9995 22.3708L17.2954 19.075L18.9287 20.7083L13.9704 25.6666ZM7.26204 18.9875L2.30371 14.0291L7.26204 9.07081L8.92454 10.7333L5.59954 14.0583L8.89538 17.3541L7.26204 18.9875ZM10.6454 8.92498L9.01204 7.29165L13.9704 2.33331L18.9287 7.29165L17.2662 8.95415L13.9412 5.62915L10.6454 8.92498ZM20.6787 18.9875L19.0162 17.325L22.3412 14L19.0454 10.7041L20.6787 9.07081L25.637 14.0291L20.6787 18.9875Z",
    fill: "#AFA9A9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlsIco);
export default __webpack_public_path__ + "static/media/controls-ico.788b6a6ed1080f16da56a378d265a6f7.svg";
export { ForwardRef as ReactComponent };